import router from '@/router';
import DataHandlerService from "@/services/data"
import CircleService from "@/services/circle"

import ExpandableMenuList from '../ExpandableMenuList/ExpandableMenuList';

const data = new DataHandlerService();
const circleService = new CircleService();

export default {
  name: "sidemenu",
  props: ["menuFor", "user", "circle", "isUserAdmin", "userCircles", "circleChildren", "loggedInUser", "PROFILE_STATES", "CIRCLE_STATES", "searchQuery", "loadPublicCircles"],
  components: {ExpandableMenuList},
  data () {
    return {
      sections: {},
      publicCircles: null,
      showPublicCircles: false
    }
  },
  computed: {
    profileURL: function() {
      let url = "";
      if (this.$props.menuFor === "feed") {
        url = `/profile/${this.$props.user._id}`;
      }
      return url;
    },
    isChildCircle: function() {
      return this.$props.circle.flags && this.$props.circle.flags.find(s => s.type === 'type').value === 'child';
    },
    isIVRCircle: function() {
      return this.$props.circle.flags && this.$props.circle.flags.find(s => s.type === 'type').value === 'ivr';
    },
  },
  created () {
    this.loadMenuCircles()
  },
  methods: {
    spawnStateChangeInCirclePage(sub, emittedState) {
      this.setCircleMenuItemsActive(sub)
      this.$emit("stateChangeFromCircleSideMenu", emittedState);
    },
    spawnStateChangeInProfilePage(sub, emittedState) {
      this.setCircleMenuItemsActive(sub)
      this.$emit("stateChangeFromProfileSideMenu", emittedState);
    },
    setCircleMenuItemsActive(sub) {
      try {
        Array.from(document.getElementsByClassName("stat-count")).forEach(el => el.classList.remove("active"));
        Array.from(document.getElementsByClassName("sidemenu-item")).forEach(el => el.classList.remove("active"));
        Array.from(document.getElementsByClassName(`${sub}_count`)).forEach(el => el.classList.add("active"));
        Array.from(document.getElementsByClassName(`${sub}_li`))[0].classList.add("active");
      } catch(e) { throw new Error(e) }
    },
    loadMenuCircles() {
      const user = data.getUserData();
      const profileId = user._id;
      const sects = ['recommended', 'created', 'administrator', 'member']

      circleService.getProfileCircleSections(profileId).then(sections => {
        let sorted = {}
        for (var i in sections) {
          if (sects.includes(i)) {
            sorted[i] = sections[i]
          }
        }
        this.sections = sorted
        try {
          this.publicCircles = sections['public']
        } catch (e) {
          console.log(e)
        }
      })
    },
  }
};
